//
// ResourceManager.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "./localization/LocalizationContext";
import "./localization/UnicodeFacility";

var ResourceManager = createModule("commons::ResourceManager", [], ClosetObject, [
    {
        FILE_NOT_FOUND: 10033,
        DECODE_BITMAP_ERROR: 10034,
        FILE_BLOB_ERROR: 10036,
        UNRESOLVED_SYMBOLIC_URL: 10035,
    },
    ,
    ,
    ,
    ,
    {
        instance: [1],
        cleanInternedStrings: [0],
        getLocalizedString: [7,7,7],
        getBundlePathTemplate: [7],
        getDPIScaleFactor: [5],
        getLocalizationContext: [1],
        setUnicodeFacility: [0,1],
        getUnicodeFacility: [1],
        setFormatterLocale: [0,7],
        getLocalizedStringForLocale: [7,7,7,7],
        updateTimers: [0],
        convertPointsToCellUnits: [5,5],
        setLocale: [0,7],
        setBundlePathTemplate: [0,7],
        convertCellToPointsUnits: [5,5],
        cleanLocalizationCache: [0],
    },
    ,
]);
export default ResourceManager;
